<template>
  <div class="preview-header">
    <div class="attachment-name usn">
      <span>{{ title }}</span>
    </div>
    <div class="preview-actions">
      <div
        v-if="showLinkButton"
        class="attachment-preview-button-wrap"
        @click="copyLink"
      >
        <em
          :style="getCustomIconStyle(iconPath('link-st'))"
          class="custom-icons attachment-preview-icons pt usn"
        />
      </div>
      <div
        v-if="showDownloadButton && !isPdf"
        class="attachment-preview-button-wrap"
        @click="downloadAttachment"
      >
        <em
          :style="getCustomIconStyle(iconPath('download'))"
          class="custom-icons attachment-preview-icons pt usn"
        />
      </div>
      <div
        v-if="showDeleteButton"
        class="attachment-preview-button-wrap"
        @click="deleteAttachment"
      >
        <em
          :style="getCustomIconStyle(iconPath('trash'))"
          class="custom-icons attachment-preview-icons pt usn"
        />
      </div>
      <div
        class="attachment-preview-button-wrap"
        @click.stop="closePreview"
      >
        <em
          :style="getCustomIconStyle(iconPath('x'))"
          class="custom-icons attachment-preview-icons"
        />
      </div>
    </div>
  </div>
</template>

<script>
import useCustomIcon from '@/utilities/composables/useCustomIcon';

export default {
  name: 'AttachmentPreviewHeader',
  inject: {
    showLinkButton: {
      default: true,
    },
    showDeleteButton: {
      default: true,
    },
    showDownloadButton: {
      default: true,
    },
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    isPdf: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['downloadAttachment', 'closePreview', 'deleteAttachment', 'copyLink'],

  setup() {
    const { iconPath, getCustomIconStyle } = useCustomIcon();

    return {
      iconPath,
      getCustomIconStyle,
    };
  },

  methods: {
    downloadAttachment() {
      this.$emit('downloadAttachment');
    },
    closePreview() {
      this.$emit('closePreview');
    },
    deleteAttachment() {
      this.$emit('deleteAttachment');
    },
    copyLink() {
      this.$emit('copyLink');
    },
  },
};
</script>

<style lang="scss">
.preview-header {
  display: flex;
  justify-content: space-between;
  position: absolute;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 4.94%, rgba(0, 0, 0, 0.595) 64.66%);
  z-index: 100;
  width: 100%;
  height: $headerFooterHeight;
  color: $white;
  top: 0;
  box-sizing: border-box;
  padding-top: 24px;

  .preview-actions {
    display: flex;
    flex-shrink: 0;
    gap: 16px;
    padding-right: 24px;

    .attachment-preview-button-wrap {
      @apply rounded flex items-center justify-center w-7 h-7 cursor-pointer select-none electron-no-drag;
    }

    > div {
      &:hover:not(.mobile *) {
        background: $gray700;
      }
      &:last-child {
        margin-left: 16px;
      }
    }

    em {
      mask-size: 16px !important;
      mask-position: center !important;
      padding: 6px;
    }
  }
}
</style>
